<template>
  <FontAwesomeIcon
    :icon="[solid ? 'fas' : 'far', name]"
    :class="size_class"
  />
</template>

<script>
// Module scope (plain <script>) so defineProps' validator can reference it.
const SIZES = { xs: 'text-xs', sm: 'text-sm', base: 'text-base', lg: 'text-lg' };
</script>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Wrapper over FontAwesome (the app standard, 'far'). Sizes map to the text scale, since icons
// inherit font-size. Icons must be registered in the library (see main.js).
const props = defineProps({
  /** A registered `far` icon name, kebab-case (`circle-check`). */
  name: {
    type: String,
    required: true,
  },
  /** `xs` · `sm` · `base` · `lg`, mapped to the text scale, since icons inherit font-size. */
  size: {
    type: String,
    default: 'base',
    validator: (value) => Object.keys(SIZES).includes(value),
  },
  /**
   * Render the solid (`fas`) variant instead of the default regular (`far`), e.g. an active nav
   * item. The solid version has to be registered too.
   */
  solid: {
    type: Boolean,
    default: false,
  },
});

const size_class = computed(() => SIZES[props.size]);
</script>
